module.exports = __webpack_public_path__ + "img/W-4.0d19c56a.jpg";